import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useCredits } from '@/contexts/CreditsContext';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { useNavigate } from 'react-router-dom';

export const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const { balance, tier, loading: creditsLoading } = useCredits();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div>
          <h1 className="h1 text-4xl mb-2">
            Welcome back, {user?.displayName || user?.email}
          </h1>
          <p className="body-text text-gray-600">
            Your AI-powered FinTech intelligence dashboard
          </p>
            </div>
            {!creditsLoading && (
              <Card className="px-6 py-4">
                <div className="text-center">
                  <p className="body-text text-sm text-gray-600 mb-1">Available Credits</p>
                  <p className="h1 text-3xl text-blazerex-green mb-1">{balance}</p>
                  <p className="body-text text-xs text-gray-500 capitalize">{tier} Plan</p>
                </div>
              </Card>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
          <Card hover>
            <h3 className="sub-header text-xl mb-2">Earnings Calls</h3>
            <p className="body-text text-gray-600 mb-4">
              Analyze earnings call transcripts with AI
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/earnings-calls')}
            >
              Explore
            </Button>
          </Card>

          <Card hover>
            <h3 className="sub-header text-xl mb-2">Earnings Calendar</h3>
            <p className="body-text text-gray-600 mb-4">
              Track upcoming earnings dates and expectations
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/earnings-calendar')}
            >
              Explore
            </Button>
          </Card>

          <Card hover>
            <h3 className="sub-header text-xl mb-2">Investor Copilot</h3>
            <p className="body-text text-gray-600 mb-4">
              Chat with AI about companies and markets
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/copilot')}
            >
              Start Chat
            </Button>
          </Card>

          <Card hover>
            <h3 className="sub-header text-xl mb-2">Financial Reports</h3>
            <p className="body-text text-gray-600 mb-4">
              Browse SEC filings and AI analysis for 10-K and 10-Q reports
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/filings')}
            >
              Explore
            </Button>
          </Card>

          <Card hover>
            <h3 className="sub-header text-xl mb-2">Rankings</h3>
            <p className="body-text text-gray-600 mb-4">
              See company rankings and comparative AI assessments
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/rankings')}
            >
              Explore
            </Button>
          </Card>
        </div>

        <Card>
          <h2 className="h2 text-2xl mb-4">Quick Actions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Button
              variant="outline"
              onClick={() => navigate('/news')}
              className="justify-start"
            >
              Latest News
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/saved')}
              className="justify-start"
            >
              Saved Analyses
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/market-movers')}
              className="justify-start"
            >
              Market Movers
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/earnings-calendar')}
              className="justify-start"
            >
              Earnings Calendar
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/filings')}
              className="justify-start"
            >
              Financial Reports
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/rankings')}
              className="justify-start"
            >
              View Rankings
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};


